import styled from "styled-components";
import { theme } from "@/styles/theme";
import { media } from "@/styles/media";
import { IFontProps } from "@/typings/Props";

type TOwnProps = {
  $width?: string;
  $backgroundColor?: string;
  $bg?: string;
  $isVisible?: boolean;
};

export default function TimeLineItem({ ...props }) {
  return (
    <Container data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="100" data-aos-duration="500">
      <ItemWrapper>
        <Line $isVisible={props.isLast} />
        <IconWrap>
          <Icon $width="30px" $backgroundColor={theme.colors.background.default}>
            <Icon $width="16px" $backgroundColor={theme.colors.primary}></Icon>
          </Icon>
        </IconWrap>
        <TimeLineWrapper>
          <TimelineContent>
            <P $fontSize="1.4rem">{props.headline}</P>
            <P $fontSize="2.2rem" $fontColor={theme.colors.primary}>
              {props.title}
            </P>
            <Textarea>{props.description}</Textarea>
          </TimelineContent>
          <TimelineImage $bg={props.image}>
            <H1>{props.imgDesc}</H1>
          </TimelineImage>
        </TimeLineWrapper>
      </ItemWrapper>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
`;

const ItemWrapper = styled.div`
  position: relative;
  width: 75%;
  height: auto;
  margin: 0 auto;
  padding-bottom: 80px;
  ${media.desktopMid`
    transform: translateX(0);
    top: -50px;
    left: 0;
    width: 100%;
    height: 100%;
  `}
`;

const Icon = styled.div<TOwnProps>`
  width: ${(props) => props.$width};
  height: ${(props) => props.$width};
  border-radius: 50%;
  padding: 5px;
  border: 2px solid ${theme.colors.primary};
  background-color: ${(props) => (props.$backgroundColor ? props.$backgroundColor : "")};
`;

const IconWrap = styled.div`
  position: relative;
  left: -63px;
  top: 30px;
  ${media.desktopMid`
      top: 80px;
      left: -33px;
  `}
`;
const Line = styled.div<TOwnProps>`
  position: absolute;
  top: 50px;
  left: -50px;
  height: 100%;
  border: 1px solid ${theme.colors.primary};
  visibility: ${(props) => (props.$isVisible ? "visible" : "hidden")};
  ${media.desktopMid`
    height: 100%;
    top: 80px;
    left: -20px;
  `}
`;

const TimeLineWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: left;
  gap: 10%;
  ${media.desktopMid`
    flex-direction: column;
    width: 95%;
    margin-left: 35px;
    margin-top: 50px;
  `}
`;
const TimelineContent = styled.div`
  width: 651px;
  height: 90%;
  ${media.desktopMid`
    width: 100%;
    height: auto;
  `}
`;

const TimelineImage = styled.div<TOwnProps>`
  position: relative;
  width: 472px;
  height: 348px;
  border-radius: 20px;
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)),
    url(${(props) => props.$bg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  ${media.desktopMid`
    width: 100%;
    background-position: center;
    margin-top: 30px;
  `}
`;
const P = styled.p<IFontProps>`
  margin-bottom: 16px;
  font-size: ${(props) => props.$fontSize};
  font-weight: ${(props) => props.$fontWeight};
  line-height: ${(props) => props.$lineHeight};
  color: ${(props) => (props.$fontColor ? props.$fontColor : `${theme.colors.text.default}`)};
  ${media.phablet`
     font-size: 1.3rem;
  `}
`;
const Textarea = styled.div`
  width: 100%;
  height: auto;
  display: block;
  white-space: pre-wrap;
  line-height: 150%;
  resize: none;
  border: none;
  color: ${theme.colors.text.graySoft};
`;
const H1 = styled.h1`
  position: absolute;
  left: 1rem;
  bottom: -0.5rem;
  color: ${theme.colors.text.white};
  ${media.mobile`
    font-size: 1.5rem;
  `}
`;
